import * as React from 'react';
import type { SVGProps } from 'react';
const SvgConversion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#4B7EFF" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M56 41V29.6c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C51.44 20 49.76 20 46.4 20H33.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C24 24.56 24 26.24 24 29.6v20.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C28.56 60 30.24 60 33.6 60H40m4-22H32m4 8h-4m16-16H32m13 24 4 4 9-9"
    />
  </svg>
);
export default SvgConversion;
